import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from '../message.service';
import { Service } from './service';
import { ApiService} from '../api.service';


@Injectable({
  providedIn: 'root'
})
export class MasterDataService {

  private MasterDataUrl = 'api/masterdata';  // URL to web api
  public services: Service[];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private messageService: MessageService
  ) { 
      this.getServices();
  }

  private getServices() {
     return this.http.get<Service[]>(this.MasterDataUrl + "/services", this.httpOptions).subscribe(
        result => this.services = result,
        error => catchError(this.messageService.handleError(error)))
    };
}
